import { PermissionCatalogueEntry } from "types/Permissions";

/** The right that makes a person an administrator; only another Master may give it. */
export const MASTER_PERMISSION = "Master";

/**
 * The order the modules appear in on every screen. A module this list does not
 * know (the backend added one) still shows, after these.
 */
const MODULE_ORDER = [
  "management",
  "documents",
  "sales",
  "people",
  "assets",
  "incoming_invoices",
  "other",
];

/** "Access all customers" -> "access_all_customers", the middle of its text keys. */
export function permissionSlug(key: string): string {
  return key.toLowerCase().replace(/[^a-z0-9]+/g, "_");
}

export function permissionNameKey(key: string): string {
  return `perm_${permissionSlug(key)}_name`;
}

export function permissionDescriptionKey(key: string): string {
  return `perm_${permissionSlug(key)}_desc`;
}

export function moduleNameKey(module: string): string {
  return `perm_module_${module}`;
}

/** The rights grouped by module, modules in MODULE_ORDER, rights in the list's own order. */
export function groupByModule(
  catalogue: PermissionCatalogueEntry[]
): { module: string; rights: PermissionCatalogueEntry[] }[] {
  const unknownModules = catalogue
    .map((right) => right.module)
    .filter((module) => !MODULE_ORDER.includes(module));
  const modules = Array.from(new Set([...MODULE_ORDER, ...unknownModules]));

  return modules
    .map((module) => ({
      module,
      rights: catalogue.filter((right) => right.module === module),
    }))
    .filter((group) => group.rights.length > 0);
}
